import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Nov 25 2019
 *
 * @///<reference path="packages/common-dp/src/core/transfer/common/model/TransferLog.ts"/>
 *
 * @author JMe
 * @author Tomáš Leity
 * @author Vojtěch Smolař
 */
import { List } from 'immutable';
import { DomainObject } from '@logio/common-be-fe';
/**
 * Details of single transfer. It contains state of processing whole transfer, data types and tables.
 * Error can occurred during transfer, this object holds only state of resources that were started
 * (it some way logs what happened).
 */

export var DPTransferLog =
/*#__PURE__*/
function (_DomainObject) {
  _inherits(DPTransferLog, _DomainObject);

  /**
   * @param id
   * @param type the transfer type
   * @param status the status of whole transfer
   * @param created the task is created but not started yet
   * @param started the start of transfer
   * @param finished the end date of processing (regardless of success or error)
   * @param dataTypes the list of data types that were being processed (regardless of success or error)
   */
  function DPTransferLog(id, type, status, created, started, finished) {
    var _this;

    var dataTypes = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : List();

    _classCallCheck(this, DPTransferLog);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DPTransferLog).call(this));
    _this.id = id;
    _this.type = type;
    _this.status = status;
    _this.created = created;
    _this.started = started;
    _this.finished = finished;
    _this.dataTypes = dataTypes;
    return _this;
  }

  return DPTransferLog;
}(DomainObject);